import React from 'react'

export default function NotFound() {

  function onClick(){
    const Usuario = JSON.parse(window.localStorage.getItem('usuario'));
    //console.log("userLayot", Usuario);
    if (Usuario == null) {
      window.location = '/';
    }else{
      window.location = '/inicio';
    }
  }

  return (
    <div className="container-fluid">

      <div className="text-center" style={{paddingTop:'25vh'}}>
        <div className="error mx-auto" data-text="404">404</div>
        <p className="lead text-gray-800 mb-5">Página no encontrada</p>
        <p className="lead text-gray-800 mb-5">Parece que la dirección no esta disponible por el momento...</p>
        <button className='btn btn-primary btn-lg' onClick={()=>onClick()}>Regresar</button>
      </div>

    </div>
  )
}
